import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, Typography, Row, Col, Spin, message } from 'antd';
import styles from './MosadDetails.module.css';
import withMosadIsolation from '../../utils/withMosadIsolation';
import { useTranslation } from '../../i18n';

const { Title, Text } = Typography;

const MosadDetails = ({ api }) => {
  const { t } = useTranslation();
//   const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [mosad, setMosad] = useState(null);
  const [error, setError] = useState(null);

  const selectedMosadCode = useSelector((state) => state.user.selectedMosadCode);

  useEffect(() => {
    const fetchMosadDetails = async () => {
      try {
        const response = await api.get(`/mosads/${selectedMosadCode}`);
        setMosad(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message || t('notifications.frontend.common.failedToLoadMosadDetails'));
        message.error(t('notifications.frontend.common.failedToLoadMosadDetails'));
        setLoading(false);
      }
    };

    fetchMosadDetails();
  }, [api, selectedMosadCode]);

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.errorContainer}>
        <Text type="danger">{error}</Text>
      </div>
    );
  }

  if (!mosad) {
    return (
      <div className={styles.errorContainer}>
        <Text>{t('notifications.frontend.common.mosadNotFound')}</Text>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <Card className={styles.card}>
        <div className={styles.header}>
          <Title level={2}>{t('ui.mosads.detailsTitle')}</Title>
        </div>

        <Row gutter={[24, 24]}>
          {/* Basic Information */}
          <Col xs={24} md={12}>
            <Card title={t('ui.mosads.basicInfo')} className={styles.infoCard}>
              <div className={styles.infoRow}>
                <Text strong>{t('ui.mosads.name')}:</Text>
                <Text>{mosad.mosad_name}</Text>
              </div>
              <div className={styles.infoRow}>
                <Text strong>{t('ui.mosads.code')}:</Text>
                <Text>{mosad.mosad_code}</Text>
              </div>
              <div className={styles.infoRow}>
                <Text strong>{t('ui.mosads.businessId')}:</Text>
                <Text>{mosad.mosad_business_id || 'N/A'}</Text>
              </div>
              <div className={styles.infoRow}>
                <Text strong>{t('ui.mosads.status')}:</Text>
                <Text>{mosad.isActive ? t('ui.mosads.active') : t('ui.mosads.inactive')}</Text>
              </div>
            </Card>
          </Col>

          {/* Bank Details */}
          <Col xs={24} md={12}>
            <Card title={t('ui.mosads.bankDetails')} className={styles.infoCard}>
              <div className={styles.infoRow}>
                <Text strong>{t('ui.mosads.bankCode')}:</Text>
                <Text>{mosad.mosad_bank_code}</Text>
              </div>
              <div className={styles.infoRow}>
                <Text strong>{t('ui.mosads.bankBranch')}:</Text>
                <Text>{mosad.mosad_bank_branch}</Text>
              </div>
              <div className={styles.infoRow}>
                <Text strong>{t('ui.mosads.bankAccount')}:</Text>
                <Text>{mosad.mosad_bank_account}</Text>
              </div>
            </Card>
          </Col>

          {/* Transaction Settings */}
          <Col xs={24}>
            <Card title={t('ui.mosads.transactionSettings')} className={styles.infoCard}>
              <div className={styles.infoRow}>
                <Text strong>{t('ui.mosads.transactionAscNumber')}:</Text>
                <Text>{mosad.mosad_tx_asc_num}</Text>
              </div>
            </Card>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default withMosadIsolation(MosadDetails); 